import radium from 'radium';
import Title from './Title.jsx';
import Subtitle from './Subtitle.jsx';
import DateTimeLocation from './DateTimeLocation.jsx';

function EventInfos(props) {
	const style = {
		container: {
			display: 'inline-block',
			width: '100%',
		},
		outerContainer: {
			margin: '0.5em 0 0',
			'@media (min-width : 768px)': {
				margin: '0.5em 0 0',
			},
		},
	};

	return (
		<div style={style.outerContainer}>
			<Title title={props.title} headlineLevel={"h2"} />
			<Subtitle subtitle={props.subtitle}  headlineLevel={"h3"} />
			<div style={style.container}>
				<div>
					<DateTimeLocation date={props.date} location={props.location} />
				</div>
			</div>
		</div>
	);
}

export default radium(EventInfos);
